import React, { FC, useCallback, useState } from 'react';
import {
  FormControl, IconButton, InputLabel, Menu, MenuItem, Select,
} from '@material-ui/core';
import styled from 'styled-components';
import { KeyboardArrowUp } from '@material-ui/icons';

const StyledFormControl = styled(FormControl)`
  width: 150px;
`;

export interface LiveStreamBoothExhibitorPanelBottomBarDeviceSelectProps {
  isStreaming: boolean;
  devices: MediaDeviceInfo[];
  selectedDeviceId: string | null;
  setSelectedDeviceId: (deviceId: string) => void;
  deviceTypeLabel: string;
}

const LiveStreamBoothExhibitorPanelBottomBarDeviceSelect: FC<LiveStreamBoothExhibitorPanelBottomBarDeviceSelectProps> = ({
  isStreaming, devices, selectedDeviceId, setSelectedDeviceId, deviceTypeLabel,
}) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null);
  const handleMenuClose = useCallback(() => setMenuAnchorEl(null), []);

  return (
    isStreaming ? (
      <>
        <IconButton size="small" onClick={(e) => setMenuAnchorEl(e.currentTarget)}>
          <KeyboardArrowUp />
        </IconButton>
        <Menu
          anchorEl={menuAnchorEl}
          keepMounted
          open={Boolean(menuAnchorEl)}
          onClose={handleMenuClose}
        >
          {devices.map((device) => (
            <MenuItem
              selected={selectedDeviceId === device.deviceId}
              value={device.deviceId}
              key={device.deviceId}
              onClick={() => {
                setSelectedDeviceId(device.deviceId as string);
                setMenuAnchorEl(null);
              }}
            >
              {device.label}
            </MenuItem>
          ))}
        </Menu>
      </>
    ) : (
      <StyledFormControl>
        <InputLabel>{deviceTypeLabel}</InputLabel>
        <Select
          value={selectedDeviceId}
          defaultValue={devices[0]?.deviceId}
          onChange={(e) => setSelectedDeviceId(e.target.value as string)}
        >
          {devices.map((camera) => (
            <MenuItem value={camera.deviceId} key={camera.deviceId}>{camera.label}</MenuItem>
          ))}
        </Select>
      </StyledFormControl>
    )
  );
};

export default LiveStreamBoothExhibitorPanelBottomBarDeviceSelect;
